<script setup lang="ts">
	const store = useOwnerRegisterStore();
	const { storeRedirectUrl } = store;
</script>

<template>
	<Block class="mt-[2.4rem] border-[lightGray] border-[.1rem] py-[2.4rem] flex flex-col justify-center items-center rounded-[.8rem]">
		<Block class="max-w-[84rem] w-full mx-auto">
			<TitleText
				class="text-center"
				type="4"
			>
				Completion
			</TitleText>
			<NuxtImg
				class="mt-[2.4rem] w-[4.8rem] h-[4.8rem] mx-auto"
				src="/img/register/ico_grin.png"
				alt="Smile icon"
			/>

			<TitleText
				class="mt-[2.4rem] text-center"
				type="5"
			>
				Thank you for registering!
			</TitleText>
			<p class="mt-[2.4rem] text-[1.6rem] leading-[1.5] text-center">
				Let's post your store information right away and promote your store even more!
			</p>

			<NuxtLink
				:to="(storeRedirectUrl) ? storeRedirectUrl : '/'"
				class="mt-[2.4rem] bg-[goldenYellow] text-primary font-bold text-[1.4rem] leading-[1.5] rounded-[1rem] p-[1rem] max-w-[25.2rem] w-full m-auto block text-center"
			>Go to Admin Page
			</NuxtLink>
		</Block>
	</Block>
</template>
